import { Breadcrumb } from "components/breadcrumb";
import DashboardContent from "modules/dashboard/DashboardContent";
import DashboardHeader from "modules/dashboard/DashboardHeader";
import DashboardSidebar from "modules/dashboard/DashboardSidebar";
import PageLoading from "pages/PageLoading";
import React, { Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import GenerateAppRoutes from "routes/GenerateAppRoutes";
import { handleCloseSidebar } from "store/sidebarReducer/sidebarSlice";
import useBreadcrumbs, {
	createRoutesFromChildren,
} from "use-react-router-breadcrumbs";
import authUtils from "utils/authUtils";

const LayoutDashboard = ({ children }) => {
	const[loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const AppRoutes = GenerateAppRoutes();
	const appRouteObjects = createRoutesFromChildren(AppRoutes);
	const breadcrumbs = useBreadcrumbs(appRouteObjects);
	const dispatch = useDispatch();
	const showSidebar = useSelector(state => state.sidebar.showSidebar);
	useEffect(() => {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);
	}, []);
	// useEffect(() => {
	// 	(async () => {
	// 		const user = await authUtils.isAuthenticated();
	// 		console.log("🚀 ~ file: LayoutDashboard.jsx ~ line 31 ~ user", user)
	// 		if (!user) {
	// 			navigate("/login");
	// 		} else {
	// 			setLoading(false);
	// 		}
	// 	})();
	// }, [navigate]);
	return loading ? (
		<div>Loading...</div>
	) : (
		<>
			<div className='flex'>
				<DashboardSidebar></DashboardSidebar>
				<DashboardContent>
					<DashboardHeader></DashboardHeader>
					<div className='flex flex-col admin-content relative px-34px bg-[#F5F5F5]'>
						<Breadcrumb breadCrumbs={breadcrumbs}></Breadcrumb>
						<Suspense fallback={<PageLoading></PageLoading>}>
							<Outlet></Outlet>
						</Suspense>
					</div>
				</DashboardContent>
				<div
					onClick={() => dispatch(handleCloseSidebar())}
					className={`overlay fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 transition-all ${
						showSidebar ? "active" : ""
					}`}></div>
			</div>
		</>
	);
};

export default LayoutDashboard;
